import { Flex } from '@chakra-ui/react'
import React from 'react'
import AppHeader from './components/AppHeader/AppHeader'
import CartDrawer from './components/CartDrawer/CartDrawer'
import { HomeFooter } from './components/Footer/HomeFooter'
import AppProviders from './routes/AppProviders'
import AppRoutes from './routes/AppRoutes'

function App() {
  return (
    <AppProviders>
      <Flex direction='column' minH='100vh'>
        <AppRoutes />
        <CartDrawer />
      </Flex>
    </AppProviders>
  )
}

export default App
